__turbopack_context__.v({
  "chart": "_4Q5mca_chart",
  "chartWrap": "_4Q5mca_chartWrap",
  "container": "_4Q5mca_container",
  "heading": "_4Q5mca_heading",
  "stats": "_4Q5mca_stats",
  "xAxisLabel": "_4Q5mca_xAxisLabel",
  "yAxisLabel": "_4Q5mca_yAxisLabel",
});
